export const ROLES = {
  USER: "User",
  SUPERVISOR: "Supervisor",
  ADDITIONAL_ACCEPTOR: "Additional Acceptor",
  COST_GROUP: "Cost Group",
  LOCAL_ADMINISTRATOR: "Local administrator",
  ACCOUNTS_PAYABLE: "Accounts Payable",
  ADMINISTRATION: "Administration",
  LOCAL_HR: "Local HR",
  SUPPORTER: "Supporter",
  MASTER_ADMIN: "Master Admin",
  LOG_VIEWER: "Log Viewer",
};
